import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7446b60a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.lbbd.gov.uk" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "logo.svg",
    alt: "Logo",
    class: "logo"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "menu-flex"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<a href=\"https://www.lbbd.gov.uk/\" data-v-7446b60a><b data-v-7446b60a>Services</b></a><a href=\"https://www.lbbd.gov.uk/make-payment\" data-v-7446b60a><b data-v-7446b60a>Pay</b></a><a href=\"https://www.lbbd.gov.uk/report-problem\" data-v-7446b60a><b data-v-7446b60a>Report</b></a><a href=\"https://www.lbbd.gov.uk/apply-or-request-council-service\" data-v-7446b60a><b data-v-7446b60a>Apply</b></a><a href=\"https://mybd.lbbd.gov.uk/\" data-v-7446b60a><b data-v-7446b60a>My B&amp;D</b></a>", 5)
const _hoisted_10 = [
  _hoisted_5
]
const _hoisted_11 = { "aria-labelledby": "Breadcrumbs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "breadcrumbs-title" }, "Breadcrumbs", -1))
const _hoisted_13 = { class: "breadcrumbs" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "breadcrumbs" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "breadcrumbs-link",
    href: "https://lbbd.gov.uk"
  }, "Home")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "breadcrumbs" }, "/ Answers", -1))
const _hoisted_16 = {
  key: 0,
  class: "breadcrumbs restart-uat"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.view !== 'uat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "menu-toggle",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                }, "Menu"),
                _createElementVNode("nav", {
                  class: _normalizeClass(["menu", { 'menu-visible': _ctx.menuVisible }])
                }, _hoisted_10, 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("nav", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("ol", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            (_ctx.view === 'uat')
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startAgain && _ctx.startAgain(...args))),
                    class: "restart-btn"
                  }, " Start Again ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}